import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md" | "lg";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const variants: Record<Variant, string> = {
  primary:
    "bg-accent text-ink-950 hover:bg-accent-soft shadow-soft disabled:opacity-60",
  secondary:
    "border border-white/15 bg-white/5 text-slate-100 hover:bg-white/10 disabled:opacity-60",
  ghost:
    "text-slate-200 hover:bg-white/5 disabled:opacity-60",
  danger:
    "bg-red-500/90 text-white hover:bg-red-500 disabled:opacity-60",
};

const sizes: Record<Size, string> = {
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-sm",
  lg: "px-5 py-3 text-base",
};

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  ...rest
}: Props) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition ${variants[variant]} ${sizes[size]} ${className}`}
      {...rest}
    />
  );
}
